import clsx from 'clsx';

type Props = {
  score: number;
  text: string;
  size?: 'small' | 'medium';
};

export default function CandidatesUserJobProcessScore({ score, text, size = 'medium' }: Props) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center gap-1 rounded border border-solid border-border bg-white',
        size === 'medium' && 'h-x4l w-[100px]',
        size === 'small' && 'h-15.5 w-20'
      )}
    >
      <p
        className={clsx(
          'font-bold',
          size === 'medium' && 'text-xl',
          size === 'small' && 'text-base',
          score === 0 && 'text-border'
        )}
      >
        {score}
      </p>
      <p className="text-xs font-bold">{text}</p>
    </div>
  );
}
